import axios from 'axios';

const updateSupraLockboxStatus = async ({
  serialNumber,
  status,
}: {
  serialNumber: string;
  status: string;
}) => {
  const { data } = await axios.post('/supra/lockbox/update_status', {
    serialNumber,
    status,
  });

  return data;
};

export default updateSupraLockboxStatus;
